import intersect from './intersect'

export default (Vue) => {
  Vue.directive('intersect', intersect)
}
